export const fonts = {
  regular: 'SailecRegular',
  bold: 'SailecBold',
  medium: 'SailecMedium',
  light: 'SailecLight',
  courierPrimeBold: 'CourierPrimeBold',
  dmMonoMedium: 'DmMonoMedium',
};
